// Tiny typed pub/sub used by engine -> store. Decouples engine from React.

export type EngineEvent =
  | { type: "engine:status"; status: import("./types").EngineStatus }
  | { type: "plan:set"; plan: import("./types").PlanTree }
  | { type: "plan:nodeUpdate"; nodeId: string; patch: Partial<import("./types").PlanNode> }
  | { type: "swarm:spawn"; agent: import("./types").SubAgentState }
  | { type: "swarm:agentUpdate"; agentId: string; patch: Partial<import("./types").SubAgentState> }
  | { type: "audit"; entry: import("./types").AuditEntry }
  | { type: "metrics"; tokensUsed: number; costUsd: number; confidence: number; risk: number }
  | { type: "dossier"; dossier: import("./types").Dossier }
  | { type: "error"; message: string };

export type EngineListener = (e: EngineEvent) => void;

export class EventBus {
  private listeners = new Set<EngineListener>();
  on(l: EngineListener) {
    this.listeners.add(l);
    return () => this.listeners.delete(l);
  }
  emit(e: EngineEvent) {
    for (const l of this.listeners) {
      try {
        l(e);
      } catch (err) {
        // do not let one listener crash the engine
        console.error("[deep-research] listener error", err);
      }
    }
  }
  clear() {
    this.listeners.clear();
  }
}
